export const schedulingErrorTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('HardStopError: Attempting to reschedule the active element') !== -1 || desyncdata.indexOf('HardStopError: Attempting to run a child element') !== -1 ||
      (desyncdata.indexOf('This will result in a partially reset object') !== -1 && desyncdata.indexOf('ResetReason.RESET_EXPECTED') !== -1)) {
			return {
				type: 'schedulingErrorTest',
				color: 'MediumAquamarine',
				title: 'Scheduling Hard Stop Error',
				text: 'Base game issue with interrupting Sim active task.',
				description: 'For the most part, you\'re safe to ignore this error.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>b1551a85061730a5af1bf33</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-05-08 12:20:12</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.30.1020-1.200.000.336.Release</buildsignature>
        <categoryid>scheduling.py:484</categoryid>
        <desyncid>b1551a85061730a5af1bf33</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>[sscholl] HardStopError processing ResetRecord:&lt;, reason:ResetReason.RESET_EXPECTED, stage:_Stage.INTERNAL_STATE_RESET, being_processed:True, source:, cause:In required sims of queued interaction.. This will result in a partially reset object (HardStopError: Attempting to reschedule the active element &lt;SoftSleep; 40.00 seconds; ready to wake; soft-stopped&gt; while a hard stop is pending)
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 196, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 203, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\services\reset_and_delete_service.py&quot;, line 550, in _process_one_record
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 1534, in on_reset_internal_state
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 1426, in on_reset
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 201, in on_reset
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 179, in clear_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\interaction_queue.py&quot;, line 294, in _clear_interaction
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 6807, in on_removed_from_queue
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4553, in _exited_pipeline
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 2538, in transition
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1308, in shutdown
  File &quot;T:\InGame\Gameplay\Scripts\Server\postures\transition_sequence.py&quot;, line 1330, in cancel_incompatible_sis_given_final_posture_states
  File &quot;T:\InGame\Gameplay\Scripts\Server\sims\sim.py&quot;, line 3064, in evaluate_si_state_and_cancel_incompatible
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\jog_interaction.py&quot;, line 192, in cancel
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4372, in cancel
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4141, in _cancel_eventually
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4225, in _cancel
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\super_interaction.py&quot;, line 4375, in _interrupt_active_work
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\base\interaction.py&quot;, line 6569, in _interrupt_active_work
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 95, in trigger_soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 534, in soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\interactions\utils\routing.py&quot;, line 527, in _soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 95, in trigger_soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 534, in soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 574, in _soft_stop
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 484, in reschedule
scheduling.HardStopError: Attempting to reschedule the active element &lt;SoftSleep; 40.00 seconds; ready to wake; soft-stopped&gt; while a hard stop is pending
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/basegame/schedulingErrorTest.js